import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiDateTimePickerComponent } from '@components/ui-datetime-picker/ui-datetime-picker.component';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ComponentSharedModule,
        UiSuggestModule,
        MatDatepickerModule,
        MatInputModule,
        MatFormFieldModule,
    ],
    declarations: [
        UiDateTimePickerComponent,
    ],
    exports: [
        UiDateTimePickerComponent,
    ],
})
export class UiDateTimePickerModule { }
